export default "<app-merch-collection [data]=\"galleryView\" [category]=\"'past'\"></app-merch-collection>\n"